import { defineComponent as _defineComponent } from 'vue'
import { downloadExcel } from '~/functions/export'
import { type AccountType, useExportByPortfolioLazyQuery } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioExcelExport',
  props: {
    portfolio: null
  },
  emits: ["finish"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'finish'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  portfolio: AccountType
};





const { onResult, refetch, loading, load } = useExportByPortfolioLazyQuery({
  fetchPolicy: 'network-only',
})

onResult((res) => {
  const file = res.data?.exportByPortfolio.file
  if (file) {
    const name = props.portfolio.name?.replace('.', '_')
    downloadExcel(file, `${name}_KPIs`)
    emit('finish')
  }
})

function triggerExcelExport() {
  load() || refetch()
}

return { __sfc: true,props, emit, onResult, refetch, loading, load, triggerExcelExport }
}

})